module.exports = __webpack_public_path__ + "img/37c3598.png";